import { appCheckFlag } from '@portal/config/app.json';
import {
  useSdkConfig,
  setTempPublicKey,
  setTempPrivateKey,
} from '@bankeiro/bankeiro-sdk-security';

import storeCreator from '@portal/reducers/createStore';
import * as StorageService from '@portal/services/storage';
import * as MessageService from '@portal/services/message';
import centralNavigationService from '@portal/services/navigation';
import { decreaseLoading, increaseLoading } from '@portal/actions/loading';
import { getMeFirstLoad } from '@portal/actions/user';
import { VALIDATE_TOKEN_SUCESS } from '@portal/actions/actionTypes';
import { AuthActions } from '@portal/actions';
import ErrorsMessages from '@portal/enum/errors';
import {
  API_URL,
  KEYCLOAK_CLIENT_ID,
  LOGIN_API_URL,
  USE_SYMMETRIC_ENCRYPTION,
} from '@portal/config/env';
import { appCheck } from '@portal/services/firebase';
import { getToken } from 'firebase/app-check';
import ApiErrorHandler from '@portal/services/ApiErrorHandler';

const {
  sdkRSAEncryptionFunctions: { decrypt, encrypt, signData, generateKeyPair },
  sdkSecurityFunctions: {
    getCleanInstance,
    getInstance,
    removeHeader,
    setHeader,
    setHandleApiError,
  },
  sdkValidateDeviceFunctions: { validateDevice },
} = useSdkConfig({
  useSymmetricEncryption: USE_SYMMETRIC_ENCRYPTION,
  apiUrl: API_URL,
  loginApiUrl: LOGIN_API_URL,
  keycloakClientId: KEYCLOAK_CLIENT_ID,
  storageService: StorageService,
  messageService: MessageService,
  centralNavigationService: centralNavigationService,
  errorMessagesEnum: ErrorsMessages,
  getPathname: () => window.location.pathname,
  increaseLoading: () => {
    storeCreator.dispatch(increaseLoading());
  },
  decreaseLoading: () => {
    storeCreator.dispatch(decreaseLoading());
  },
  onValidateTokenSuccess: (payload: boolean) => {
    storeCreator.dispatch({ payload, type: VALIDATE_TOKEN_SUCESS });
  },
  getMeFirstLoad: () => {
    storeCreator.dispatch(getMeFirstLoad());
  },
  logout: () => {
    storeCreator.dispatch(AuthActions.logout());
  },
  useAppCheck: appCheckFlag?.enabled && appCheck !== null,
  onAppCheckGenerateToken: async () => {
    if (!appCheck) {
      throw new Error('App Check not initialized');
    }
    const { token } = await getToken(appCheck, true);
    return token;
  },
});

setHandleApiError(ApiErrorHandler.handle);

export {
  validateDevice,
  decrypt,
  encrypt,
  signData,
  generateKeyPair,
  getCleanInstance,
  getInstance,
  removeHeader,
  setHeader,
  setTempPublicKey,
  setTempPrivateKey,
};
